import React from 'react';
import ProductModifierGroupSimpleOptionIncluded from "./ProductModifierGroupSimpleOptionIncluded";
import {useTranslation} from "react-i18next";
import MenuEditItemStateHelper from "../../../../../../../services/Menu/services/State/MenuEditItemStateHelper";
import ProductModifierGroupAdvancedOptionIncluded from "./ProductModifierGroupAdvancedOptionIncluded";

interface Props {
    includedModifierGroups: Record<string, any>[];
    updateProductState: (productState: Record<string, any>) => void;
    productState: Record<string, any>;
    isProductAvailable: boolean;
    isProductASet: boolean;
}

const ProductModifierGroupOptionsIncluded = ({
                                                 includedModifierGroups,
                                                 productState,
                                                 updateProductState,
                                                 isProductAvailable,
                                                 isProductASet
                                             }: Props) => {
    const {t} = useTranslation();

    if (includedModifierGroups.length === 0 || !isProductASet) return <></>;

    const adjustOption = (modifierGroup: Record<string, any>, state: Record<string, any>, stateIndex: number) => {
        const newState = JSON.parse(JSON.stringify(state));
        const newProductState = JSON.parse(JSON.stringify(productState));
        const modifierGroupIndex = newProductState.modifier_groups.findIndex((group: Record<string, any>) => group.modifier_group_id === modifierGroup.id);
        const selectedItemIndex = newProductState.modifier_groups[modifierGroupIndex].selected_items.findIndex((item: Record<string, any>) => item.item_id === state.item_id);
        newProductState.modifier_groups[modifierGroupIndex].selected_items[selectedItemIndex + stateIndex] = newState;
        updateProductState(newProductState);
    }

    return (
        <fieldset className="form-group">
            <legend aria-live="polite">
                <h5>
                    {t("modules.menu.field.modifier_groups_included.title")}
                </h5>
            </legend>
            <div className="d-flex flex-column gap-2">
                {includedModifierGroups.map(modifierGroup => {
                    const isAdvanced = MenuEditItemStateHelper.isModifierGroupAdvanced(modifierGroup);

                    return modifierGroup.options.map((option: Record<string, any>) => {
                        if (isAdvanced) {
                            return (
                                <ProductModifierGroupAdvancedOptionIncluded key={option.id} option={option}
                                                                            isProductAvailable={isProductAvailable}
                                                                            adjustOption={(optionState, stateIndex) => adjustOption(modifierGroup, optionState, stateIndex)}
                                />
                            )
                        }

                        return (
                            <ProductModifierGroupSimpleOptionIncluded key={option.id} option={option}/>
                        )
                    })
                })}
            </div>
        </fieldset>
    )
}

export default ProductModifierGroupOptionsIncluded;